module.exports = __webpack_public_path__ + "img/xak_logo.297ab951.png";